'use strict';

// Models
import Models from './models/index';

// Services
import CampaignSettingHttpService from './services/campaign-setting/campaign-setting-http-service';
import ContentBlockHttpService from './services/content-block/content-block-http-service';
import LoreHttpService from './services/lore/lore-http-service';
import UserHttpService from './services/user/user-http-service';

// Utils
import HttpService from './services/browser-http-service';

// Config
import config from './config';

export default {
  Models,
  Services: {
    CampaignSettingHttpService,
    ContentBlockHttpService,
    LoreHttpService,
    UserHttpService
  },
  HttpService,
  config
}